import { StringMap } from './BaseRemoteApi';

class QueryParameters {
    static buildParameters(parameters?:  StringMap): string {
        if (typeof  parameters === 'undefined' || parameters === null) { return '' }

        return Object.keys(parameters).map( key => {
            return  `${key}=${parameters[key]}`
        }).join('&')
    }
}

export default QueryParameters;
